import { apiClient } from "./apiClient";

export interface SpotlightShop {
  id: string;
  name: string;
  slug?: string;
  category: string;
  rating: number;
  location: string;
  image: string;
}

export interface SpotlightData {
  title: string;
  count: number;
  subtitle: string;
  ctaText: string;
  category: string;
  image: string;
  badge?: string;
  serviceCategories?: string[];
  shops: SpotlightShop[];
}

export interface SpotlightsResponse {
  restaurants: SpotlightData;
  services: SpotlightData;
}

export const fallbackSpotlights: SpotlightsResponse = {
  restaurants: {
    title: "Restaurants",
    count: 0,
    subtitle: "Explore food & dining near your location",
    ctaText: "Explore shops",
    category: "Restaurants",
    image: "/deals/spotlight_food_platter.jpg",
    shops: [],
  },
  services: {
    title: "Book Trusted Services Fast",
    count: 0,
    subtitle: "Home cleaning, beauty, repairs and more, all in one place.",
    ctaText: "Explore services",
    category: "Services",
    image: "/deals/spotlight_home_service.jpg",
    serviceCategories: [],
    shops: [],
  },
};

export async function fetchSpotlights(params?: {
  location?: string;
  lat?: number | null;
  lng?: number | null;
}): Promise<SpotlightsResponse> {
  const queryParams: Record<string, string> = {};
  if (params?.location) queryParams.location = params.location;
  if (params?.lat != null) queryParams.lat = String(params.lat);
  if (params?.lng != null) queryParams.lng = String(params.lng);

  try {
    const res = await apiClient.get<any>(`/loyalty/public/spotlights`, queryParams);
    if (res.success && res.data) {
      return {
        restaurants: res.data.restaurants || fallbackSpotlights.restaurants,
        services: res.data.services || fallbackSpotlights.services,
      };
    }
    return fallbackSpotlights;
  } catch (error) {
    console.warn("fetchSpotlights failed:", error);
    return fallbackSpotlights;
  }
}
